import type { Space } from '@cocoonspace/sdk-js/types/space'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'
import { useSearchParams } from 'next/navigation'

import { Price } from '~/components/price'

export const TimeBasedPrice = ({
	type,
	space,
	className,
}: {
	type: 'hour' | 'day'
	space: Pick<Space, 'price' | 'prices'>
	className?: string
}) => {
	const searchParams = useSearchParams()
	const { t } = useLingui()

	const computeDuration = () => {
		const day = searchParams.getAll('day')
		const legacyDay = searchParams.get('day')
		const start = searchParams.get('start')
		const end = searchParams.get('end')

		if (type === 'day') {
			// * a workaround to handle both ways to manage multiple days query params
			// * the in-house one: "?day[]=1&day[]=2" (for instance from the search page)
			// * and the one from nuqs: "?day=1,2" (from venue landing page)
			let count = 1

			if (day.length > 0) {
				count = day.length
			} else if (legacyDay) {
				count = legacyDay.split(',').length
			}

			return count === 1 ? t`1 jour` : t`${count} jours`
		}

		const duration = dateTimeUtils(end as string, 'hh:mm').diff(
			dateTimeUtils(start as string, 'hh:mm'),
			'hour',
			true,
		)

		if (duration === 0.5) return t`1/2h`

		return dateTimeUtils
			.duration(duration, 'hour')
			.format('H[h]mm')
			.replace('h00', 'h')
	}

	const duration = computeDuration()

	return (
		<div className={cn('flex flex-col items-end gap-y-1', className)}>
			<span className='text-xs'>{t`Pour ${duration}`}</span>
			<Price price={space.price} />
		</div>
	)
}
